import { render } from "./StepParebrise.vue?vue&type=template&id=61f2e38a"
import script from "./StepParebrise.vue?vue&type=script&lang=js"
export * from "./StepParebrise.vue?vue&type=script&lang=js"

import "./StepParebrise.vue?vue&type=style&index=0&id=61f2e38a&lang=css"

import exportComponent from "/home/marwin/projects/123parebrise/appointment-module/src-js/frontend-shortcode-appointment-module/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__